var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMsal } from '@azure/msal-react';
import { Box, Button, Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { loginRequest } from '../../../../auth-config';
import useTranslate from '../../../../localization/helpers';
import LoginButtonIcon from './loginButtonIcon';
import logo from './logo.svg';
import microsoft from './microsoft.png';
import SideImage from './side-image.jpg';
import './style.scss';
var Login = function () {
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    var isIpad = useMediaQuery('(min-width: 600px) and (max-width: 1024px)');
    var instance = useMsal().instance;
    var login = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, instance.loginRedirect(loginRequest)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Container, { maxWidth: false, className: 'login-bg', children: _jsx(Grid, { container: true, spacing: { lg: 2, xs: 0 }, padding: isXs ? '0' : '36px', height: '100vh', justifyContent: isIpad ? 'center' : undefined, children: isXs || isIpad ? (_jsxs(_Fragment, { children: [isLgUp ? (_jsx(Grid, { container: true, size: { xs: 12, sm: 4, md: 6 }, sx: {
                            height: 'calc(52vh - 31px)',
                            borderRadius: '52px',
                            backgroundImage: "url(".concat(SideImage, ")"),
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: function (t) {
                                return t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900];
                            },
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            display: 'flex',
                            justifyContent: 'center'
                        } })) : (''), _jsx(Grid, { container: true, size: { xs: 12, sm: 6, md: 6 }, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '0px',
                            justifyContent: 'center'
                        }, children: _jsxs(Box, { sx: {
                                my: isXs || isIpad ? undefined : 8,
                                mx: isXs || isIpad ? undefined : 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '100%',
                                maxWidth: { xs: '100%', md: 650 }
                            }, children: [_jsx(Box, { children: _jsx("img", { src: logo, alt: 'logo', width: isXs ? '100px' : '212px', height: isXs ? '100px' : '212px' }) }), _jsx(Box, { mt: { xs: 3, lg: '50px' }, width: isLgUp ? 'auto' : '100%', children: _jsx(Button, { size: 'large', fullWidth: isLgUp ? false : true, variant: isLgUp ? 'outlined' : 'contained', color: isLgUp ? 'primary' : 'inherit', onClick: login, startIcon: _jsx(LoginButtonIcon, {}), children: translate('login.loginText') }) })] }) })] })) : (_jsxs(_Fragment, { children: [_jsx(Grid, { container: true, size: { xs: 12, sm: 6, md: 6 }, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '0px',
                            justifyContent: 'center'
                        }, children: _jsxs(Box, { sx: {
                                my: isXs ? undefined : 8,
                                mx: isXs ? undefined : 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%',
                                maxWidth: { xs: '100%', md: 650 }
                            }, children: [_jsx(Box, { children: _jsx("img", { src: logo, alt: 'logo', width: isXs ? '100px' : '212px', height: isXs ? '100px' : '212px' }) }), _jsx(Box, { marginTop: '50px', children: _jsxs(Button, { onClick: login, size: 'large', sx: {
                                            gap: '8px',
                                            borderRadius: '8px',
                                            padding: '0px 16px 0px 16px',
                                            border: '1px solid #00937E7A'
                                        }, children: [_jsx("img", { src: microsoft, alt: 'microsoft-logo', height: '24px', width: '24px' }), _jsx(Typography, { fontSize: '15px', fontWeight: 700, color: '#009983', children: translate('login.loginText') })] }) })] }) }), _jsx(Grid, { container: true, size: { xs: 12, sm: 4, md: 6 }, sx: {
                            borderRadius: '52px',
                            backgroundImage: "url(".concat(SideImage, ")"),
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: function (t) {
                                return t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900];
                            },
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            display: 'flex',
                            justifyContent: 'center'
                        } })] })) }) }));
};
export default Login;
